import { FuneralPreArrangementFinalDispositionType } from '/@/modules/asset/constants/FuneralPreArrangementFinalDispositionType';
import { FuneralPreArrangementCeremonyType } from '/@/modules/asset/constants/FuneralPreArrangementCeremonyType';
import { FuneralPreArrangementCategoryType } from '/@/modules/asset/constants/FuneralPreArrangementCategoryType';
import { FuneralPreArrangementServiceType } from '/@/modules/asset/constants/FuneralPreArrangementServiceType';

export class FuneralPreArrangementAssetMeta {
  /**
   * @var {string}
   */
  category;

  /**
   * @var {?string}
   */
  serviceProviderName;

  /**
   * @var {?string}
   */
  finalDispositionType;

  /**
   * @var {?string}
   */
  finalDispositionNote;

  /**
   * @var {?string}
   */
  serviceType;

  /**
   * @var {?string}
   */
  ceremonyType;

  /**
   * @var {?string}
   */
  ceremonyTypeNote;

  /**
   * @var {?string}
   */
  specialRequestNote;

  /**
   * @var {?string}
   */
  additionalDetails;

  constructor(model = {}) {
    this.category = model.category;
    this.serviceProviderName = model.serviceProviderName;
    this.finalDispositionType = model.finalDispositionType;
    this.finalDispositionNote = model.finalDispositionNote;
    this.serviceType = model.serviceType;
    this.ceremonyType = model.ceremonyType;
    this.ceremonyTypeNote = model.ceremonyTypeNote;
    this.specialRequestNote = model.specialRequestNote;
    this.additionalDetails = model.additionalDetails;
  }

  /**
   *
   * @returns {string}
   */
  get title() {
    return this.serviceProviderName;
  }

  /**
   * @returns {boolean}
   */
  get isCategoryFuneralHome() {
    return this.category === FuneralPreArrangementCategoryType.FUNERAL_HOME.key;
  }

  /**
   * @returns {boolean}
   */
  get isCategoryCemeteryProperty() {
    return this.category === FuneralPreArrangementCategoryType.CEMETERY_PROPERTY.key;
  }

  /**
   * @returns {boolean}
   */
  get isFinalDispositionTypeOther() {
    return this.finalDispositionType === FuneralPreArrangementFinalDispositionType.OTHER.key;
  }

  /**
   * @returns {boolean}
   */
  get isCeremonyTypeTraditional() {
    return this.ceremonyType === FuneralPreArrangementCeremonyType.TRADITIONAL_CEREMONY.key;
  }

  /**
   * @returns {boolean}
   */
  get isFinalDispositionTypeLetExecutorDecide() {
    return (
      this.finalDispositionType ===
      FuneralPreArrangementFinalDispositionType.LET_EXECUTOR_DECIDE.key
    );
  }

  unsetForFinalDispositionTypeLetExecutorDecide() {
    this.finalDispositionNote = null;
    this.serviceType = null;
    this.ceremonyType = null;
    this.ceremonyTypeNote = null;
  }

  unsetForServiceTypeNoService() {
    this.ceremonyType = null;
    this.ceremonyTypeNote = null;
  }

  unsetPlannedFuneralPreArrangements() {
    this.finalDispositionType = null;
    this.finalDispositionNote = null;
    this.serviceType = null;
    this.ceremonyType = null;
    this.ceremonyTypeNote = null;
    this.specialRequestNote = null;
  }

  /**
   * @returns {string}
   */
  get finalDispositionTypeValue() {
    return FuneralPreArrangementFinalDispositionType.getByKey(this.finalDispositionType)?.value;
  }

  /**
   * @returns {?string}
   */
  get finalDispositionDisplayValue() {
    if (this.isFinalDispositionTypeOther) {
      return this.finalDispositionNote;
    }

    return this.finalDispositionTypeValue;
  }

  /**
   * @returns {string}
   */
  get serviceTypeValue() {
    return FuneralPreArrangementServiceType.getByKey(this.serviceType)?.value;
  }

  /**
   * @returns {string}
   */
  get serviceTypeDescription() {
    return FuneralPreArrangementServiceType.getByKey(this.serviceType)?.description;
  }

  /**
   * @returns {string}
   */
  get ceremonyTypeValue() {
    return FuneralPreArrangementCeremonyType.getByKey(this.ceremonyType)?.value;
  }

  /**
   * @returns {string}
   */
  get ceremonyTypeDescription() {
    return FuneralPreArrangementCeremonyType.getByKey(this.ceremonyType)?.description;
  }
}
